import { useNavigate } from "react-router-dom";
import React, { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import NotificationsAlert from "../../services/NotificationsAlert";
import { ClienteContext } from "../../services/ClienteContext";
import Conect from "../../../Api/Conect";

import "./styles.css";
import Logo from '../../assets/Logo 300x300N.png'


const UserLogin = () => {

    const history = useNavigate();
    const { register, handleSubmit, setValue } = useForm({
        defaultValues: {
            login: "",
            password: ""
        }
    });
    const cliente = useContext(ClienteContext);
    const [saveDataUser, setSaveDataUser] = useState(false)

    useEffect(() => {
        loadSavedLogin();
        verifyToken()
        // eslint-disable-next-line
    }, [])

    const verifyToken = async () => {

        let token = localStorage.getItem("token")

        if (token !== undefined) {
            const auth = await Conect.get(`/verify${token}`)
            console.log(auth.data)
            if (auth.data.error === false) {
                NotificationsAlert("default", "", auth.data.msg)
                history("/home");
            } else {
                // NotificationsAlert("warning", "Atenção", auth.data.msg)
                history("/login");
            }
        }
    };

    const onSubmit = async (data) => {
        const savedLogin = localStorage.getItem("savedLogin") || "";
        const savedPassword = localStorage.getItem("savedPassword") || "";

        const login = data.login || savedLogin;
        const password = data.password || savedPassword;

        if (!login || !password) {
            NotificationsAlert("warning", "Atenção", "Preencha login e senha");
            return;
        }

        const usuario = await Conect.post("/login", {
            login,
            password
        });
        if (usuario.data.error === true) {
            if (usuario.data.aut === true) {
                NotificationsAlert("danger", "Atenção", usuario.data.msg)
            } else {
                NotificationsAlert("warning", "Atenção", usuario.data.msg)
            }
        }
        else if (usuario.data.error === false) {
            localStorage.setItem("id", usuario.data.data.id)
            localStorage.setItem("firstName", usuario.data.data.firstName)
            localStorage.setItem("lastName", usuario.data.data.lastName)
            localStorage.setItem("access", usuario.data.data.accessLevel)
            localStorage.setItem("token", usuario.data.data.token)

            cliente.setDados({
                user_id: usuario.data.data.id,
                name: `${usuario.data.data.firstName} ${usuario.data.data.lastName}`,
                token: usuario.data.data.token,
                position: usuario.data.data.accessDescription,
                image: usuario.data.data.image,
                id_cli: usuario.data.data.id_cli
            });
            let message = `Olá! ${usuario.data.data.firstName}!`
            NotificationsAlert("default", message, "")
            // Salva ou remove os dados de login e senha
            if (saveDataUser) {
                localStorage.setItem("savedLogin", data.login === '' ? savedLogin : data.login);
                localStorage.setItem("savedPassword", data.password === '' ? savedPassword : data.password);
                localStorage.setItem("savedSavad", saveDataUser);
            } else {
                localStorage.removeItem("savedLogin");
                localStorage.removeItem("savedPassword");
                localStorage.removeItem("savedSavad");
            }
            history("/home");
        }
    };

    // Carrega os dados de login e senha salvos no localStorage (se existirem)
    // eslint-disable-next-line
    const loadSavedLogin = () => {
        const savedLogin = localStorage.getItem("savedLogin") || "";
        const savedPassword = localStorage.getItem("savedPassword") || "";
        const savedSave = localStorage.getItem("savedSavad");

        setValue("login", savedLogin);
        setValue("password", savedPassword);
        setSaveDataUser(savedSave === "true");
    };

    return (
        <div style={{ width: '100vw', display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="container-login">
                <div className="wrap-login">
                    <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
                        <span className="login-form-title"> Bem vindo! </span>

                        <span className="login-form-title">
                            <img src={Logo} alt="Sakamotto Server Logo" />
                        </span>

                        <div className="wrap-input">
                            <input
                                className="input"
                                type="text"
                                {...register("login")}
                            />
                            <span className="focus-input" data-placeholder="Login"></span>
                        </div>

                        <div className="wrap-input">
                            <input
                                className="input"
                                type="password"
                                {...register("password")}
                            />
                            <span className="focus-input" data-placeholder="Password"></span>
                        </div>
                        <div className="div-savelogin">
                            <span>Salvar login? </span>
                            <input
                                type="checkbox"
                                checked={saveDataUser}
                                onChange={() => setSaveDataUser(!saveDataUser)}
                            />
                        </div>
                        <div className="container-login-form-btn">
                            <button className="login-form-btn">Login</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    )

}

export default UserLogin;
